import { useEffect, useRef, useState } from "react";
import PrimaryButton from "../PrimaryButton";
import SkeletonList from "../Skeletons/SkeletonList";
import StepperItem from "./StepperItem";

function getPositionRelativeToDiv(div1, div2) {
    // Get bounding rectangle of both divs
    const rect1 = div1.getBoundingClientRect();
    const rect2 = div2.getBoundingClientRect();

    // Calculate relative position of div2 to div1
    const relativePosition = {
        top: rect2.top - rect1.top,
        left: rect2.left - rect1.left,
    };

    return relativePosition;
}

const Stepper = ({ steps, activeStep, setActiveStep, renderAsync }) => {

    const [left, setLeft] = useState(0)
    const stepHeaderRefs = useRef([])
    const containerRef = useRef()
    const sliderRef = useRef()

    useEffect(() => {
        const activeStepperHeaderRef = stepHeaderRefs.current?.[activeStep.index]
        if (activeStepperHeaderRef && containerRef.current) {
            const position = getPositionRelativeToDiv(containerRef.current, activeStepperHeaderRef)
            setLeft(position.left)
        }
    }, [activeStep.index])
    return (
        <div className="w-full flex flex-col gap-[40px]">
            <div className="bg-white w-full flex flex-row rounded-xl p-[25px] items-center justify-between relative border-[2px] border-gray-100" ref={containerRef}>
                <div className="flex flex-row gap-[25px] items-center h-[40px] ">
                    {steps.map((step, index) => {
                        return (
                            <div className={`flex flex-row gap-[5px] items-center select-none ${index > activeStep.index ? "opacity-70 cursor-not-allowed" : " cursor-pointer"}`} ref={(el) => (stepHeaderRefs.current[index] = el)} onClick={() => {
                                if (index >= activeStep.index) return
                                setActiveStep({ index, direction: index > activeStep.index ? "right" : "left" })
                            }} >
                                <div className="w-[25px] h-[25px] rounded-full border-1 border-[#7059ef] bg-[#f7f5ff] text-[#7059ef] flex items-center justify-center text-[14px]">
                                    {activeStep.index > index ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="w-[14px] h-[14px]"><path d="M13.3333 4L5.99999 11.3333L2.66666 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path></svg> :
                                        index + 1
                                    }
                                </div>
                                <div className={`${activeStep.index === index ? "text-[#7059ef]" : "text-black"} text-[14px] duration-300`}>

                                    {step.name}
                                </div>
                            </div>
                        )
                    })}
                    <div className="duration-300 absolute bottom-0 h-[3px] bg-[#7059ef]" style={{ width: stepHeaderRefs.current?.[activeStep.index]?.scrollWidth, left }} ></div>
                    <div>

                    </div>

                </div>
                {activeStep.index !== steps.length && steps[activeStep.index]?.button?.name &&
                    <PrimaryButton
                        onClick={() => {
                            const callback = steps[activeStep.index]?.button.callback
                            callback?.()
                        }}
                        value={steps[activeStep.index]?.button?.name} >

                    </PrimaryButton>
                }
            </div>

            <div className={`${steps?.[activeStep.index]?.backgroundStyle} w-full flex flex-row rounded-xl items-center justify-between relative relative w-full  overflow-hidden relative`} ref={sliderRef}>

                {steps.map((step, index) => {


                    return (
                        <StepperItem activeStep={activeStep} step={step} renderAsync={renderAsync} index={index}>
                            {step?.component}
                        </StepperItem>
                    )
                })}

            </div>

        </div>



    );
};

export default Stepper;
